import {
  MAX_UPLOADED_IMAGE_SIZE_IN_MB,
  QUALITY_REDUCE_RATIO,
  STANDARD_IMAGE_DEFAULT_SIZE
} from "../constants/input-entries-constants";

export const imageHelper = {
  getImageFileSize(base64String: string): number {
    // Remove the header if it exists
    if (base64String.startsWith("data:image")) {
      base64String = base64String.split(",")[1];
    }

    // Decode the Base64 string
    const binaryString = atob(base64String);

    // Calculate the size in bytes
    const sizeInBytes = binaryString.length;

    // Convert bytes to megabytes
    const sizeInMB = sizeInBytes / (1024 * 1024);

    return sizeInMB;
  },
  resizeBase64Image: async (base64Image: string): Promise<string> => {
    return new Promise((resolve) => {
      const maxSizeInMB = MAX_UPLOADED_IMAGE_SIZE_IN_MB;
      const maxSizeInBytes = maxSizeInMB * STANDARD_IMAGE_DEFAULT_SIZE;
      const img = new Image();
      img.src = base64Image;
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const width = img.width;
        const height = img.height;
        const aspectRatio = width / height;
        const newWidth = Math.sqrt(maxSizeInBytes * aspectRatio);
        const newHeight = Math.sqrt(maxSizeInBytes / aspectRatio);
        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        let quality = QUALITY_REDUCE_RATIO;
        let dataURL = canvas.toDataURL("image/png", quality);
        let imageSizeInBytes = dataURL.length * (3 / 4);
        while (imageSizeInBytes > maxSizeInBytes) {
          canvas.width *= 0.9;
          canvas.height *= 0.9;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          dataURL = canvas.toDataURL("image/png", quality);
          imageSizeInBytes = dataURL.length * (3 / 4);
        }
        return resolve(dataURL);
      };
    });
  }
};
